// extracted by mini-css-extract-plugin
export default {"ticket":"MyTickets_ticket__DbmlQ","containerDetail":"MyTickets_containerDetail__4aRQu","detail":"MyTickets_detail__55FIq","info":"MyTickets_info__0rk7g"};